import { adminMutation } from "@/admin/utils/adminMutation.ts";
import type { ApiClient } from "@/modules/api/apiClient.ts";
import { getResponseData } from "@/modules/api/apiClient.ts";
import { jsonEncodedBody } from "@/utils/fetchClient.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { queryOptions, type QueryKey } from "@tanstack/react-query";
import type { ReferralAmounts } from "@warrenio/api-spec/spec.oats.gen";

const queryKey: QueryKey = ["config/payment/referral_amounts"];

function getQuery(client: ApiClient) {
    return queryOptions({
        queryKey,
        queryFn: async ({ signal }): Promise<ReferralAmounts> => {
            return getResponseData(await client.GET("/config/payment/referral_amounts", { signal }));
        },
    });
}

export const referralAmountsQueryAtom = atomFromStandardQueryOptions(getQuery);

//#region Mutations

export const updateAmountsMutation = adminMutation((apiClient) => ({
    entity: "Referral amounts",
    operation: "update",
    requestFn: async ({ body }: { body: ReferralAmounts }) =>
        await apiClient.PUT("/config/payment/referral_amounts", {
            ...jsonEncodedBody,
            body,
        }),
    invalidateQueryKey: queryKey,
}));

//#endregion Mutations
